module.exports = __webpack_public_path__ + "static/logo-5b4356d191c11d786d295da2053a4f2b.png";